import SuAdminPayment from './SuAdminPayment';
export default SuAdminPayment;